<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'CopyrightDefault',

  props: {
    alignment: {
      type: String as PropType<'center' | 'left' | 'right'>,
      default: 'left',
    },
  },
})
</script>

<template>
  <div
    :class="['o-label__copyright', `is-${alignment}`]">
    <p class="o-label__copyright--item">
      <slot>
        &copy; 株式会社ビズヒント
      </slot>
    </p>
  <!-- /.o-label__copyright --></div>
</template>

<style lang="sass" scoped>
.o-label__copyright
  $root: &
  display: flex
  flex-direction: column
  align-items: center

  & &--item
    color: $font-light-gray
    font-size: $font-x-small

  &.is-center
    #{$root}--item
      text-align: center

  &.is-right
    #{$root}--item
      text-align: right

  +breakpoint($max-media: tablet)
    &.is-center,
    &.is-right
      #{$root}--item
        text-align: left
</style>
